function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 14.0004,
  cy: 12.9999,
  rx: 13.6708,
  ry: 12.9999,
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M23.1139 8.0389C22.4851 8.2999 21.8094 8.4763 21.1003 8.55566C21.8242 8.1495 22.38 7.50633 22.6418 6.74001C21.9536 7.12229 21.2007 7.39163 20.4155 7.53639C19.776 6.8986 18.8649 6.5 17.8565 6.5C15.9202 6.5 14.3504 7.96941 14.3504 9.78175C14.3504 10.039 14.3815 10.2894 14.4412 10.5297C11.5275 10.3928 8.94419 9.08628 7.21498 7.10074C6.91326 7.58544 6.74037 8.14925 6.74037 8.75061C6.74037 9.88923 7.35936 10.8937 8.30003 11.4822C7.74329 11.4659 7.19879 11.3252 6.712 11.0717C6.7118 11.0855 6.7118 11.0992 6.7118 11.113C6.7118 12.7031 7.92028 14.0295 9.52407 14.331C9.0078 14.4625 8.46627 14.4817 7.94084 14.3873C8.38694 15.6911 9.68173 16.6399 11.2158 16.6664C10.016 17.5466 8.50423 18.0713 6.86173 18.0713C6.5787 18.0713 6.29967 18.0557 6.02539 18.0254C7.57691 18.9566 9.41973 19.4999 11.3996 19.4999C17.8483 19.4999 21.3746 14.4991 21.3746 10.1624C21.3746 10.02 21.3713 9.87848 21.3645 9.73776C22.0508 9.27329 22.6433 8.69801 23.1139 8.0389Z",
  fill: "#20205E"
});

var SvgTwitterWhite = function SvgTwitterWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTwitterWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter-white.76422916.svg";
export { ForwardRef as ReactComponent };